import { computed as mobxComputed } from 'mobx';
var ComputedClass = /** @class */ (function () {
    function ComputedClass(callback) {
        this.callback = callback;
    }
    ComputedClass.prototype.get = function () {
        var _this = this;
        this.instance =
            this.instance ||
                mobxComputed(function () {
                    return _this.callback(_this.getState().state, _this.getState().root);
                });
        return this.instance.get();
    };
    return ComputedClass;
}());
export { ComputedClass };
export function Computed(callback) {
    return new ComputedClass(callback);
}
//# sourceMappingURL=Computed.js.map


//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/@cerebral/fluent/es/Computed.js
// module id = 27
// module chunks = 0